import script from "./SearchTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchTable.vue?vue&type=script&setup=true&lang=js"

import "./SearchTable.vue?vue&type=style&index=0&id=f32e1b6e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f32e1b6e"]])

export default __exports__